var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('v-button',{staticClass:"btn-primary",attrs:{"disabled":_vm.isDeleted,"working":_vm.loading},nativeOn:{"click":function($event){return _vm.remove()}}},[_vm._v("\n    "+_vm._s(_vm.label || "Löschen")+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }